import { useStats } from 'react-instantsearch';

export function CustomStats() {
  const {
    nbHits
  } = useStats();

  return (
  <span className="customStatsResults">{nbHits.toLocaleString()} result{nbHits > 1 ? 's' : ''}</span>
  )
}